// https://stackoverflow.com/questions/72768/how-do-you-detect-credit-card-type-based-on-number
export const CARD_PATTERNS = {
  VISA: /^4[0-9]{6,}$/,
  MASTERCARD: /^5[1-5][0-9]{5,}|222[1-9][0-9]{3,}|22[3-9][0-9]{4,}|2[3-6][0-9]{5,}|27[01][0-9]{4,}|2720[0-9]{3,}$/,
  AMERICAN_EXPRESS: /^3[47][0-9]{5,}$/,
  DINERS: /^3(?:0[0-5]|[68][0-9])[0-9]{4,}$/,
  DISCOVER: /^6(?:011|5[0-9]{2})[0-9]{3,}$/,
  JCB: /^(?:2131|1800|35[0-9]{3})[0-9]{3,}$/,
  STAR: /^5008.*$/,
  NYCE: /^5015.*$/,
  PULSE: /^6029.*$/,
};

export const CARD_NUMBER_REGXP = /^([0-9]{4}\s?){2}([0-9]{1,4}\s?){0,3}$/;
export const ZIP_CODE_REGXP = /^[0-9\-]{1,9}$/;
export const CANADA_ZIP_CODE_REGXP = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
export const CANADA_ZIP_CODE_FORBIDDEN_CHARACTERS = /[^A-Za-z\d -]/g;
export const PHONE_REGXP = /^[0-9\-]{1,15}$/;
export const ROUTING_NUMBER_REGXP = /^[0-9]{9}$/;
export const ACCOUNT_NUMBER_REGXP = /^[0-9]{4,17}$/;
export const EFT_ACCOUNT_NUMBER_REGXP = /^[0-9]{5,12}$/;
export const INSTITUTION_NUMBER_REGXP = /^[0-9]{3}$/;
export const BRANCH_NUMBER_REGXP = /^[0-9]{5}$/;

export const PRE_MUTATE_EFT_ACCOUNT_NUMBER_REGXP = /^[0-9]{0,12}$/;
export const PRE_MUTATE_INSTITUTION_NUMBER_REGXP = /^[0-9]{0,3}$/;
export const PRE_MUTATE_BRANCH_NUMBER_REGXP = /^[0-9]{0,5}$/;
export const PRE_MUTATE_CARD_NUMBER_REGXP = /^([0-9]{0,4}\s?){0,5}$/;
export const PRE_MUTATE_ZIP_CODE_REGXP = /^[0-9\-]{0,9}$/;
export const PRE_MUTATE_PHONE_REGXP = /^[0-9\-]{0,15}$/;
export const PRE_MUTATE_ROUTING_NUMBER_REGXP = /^[0-9]{0,9}$/;
export const PRE_MUTATE_ACCOUNT_NUMBER_REGXP = /^[0-9]{0,17}$/;

export const DIGITS_ONLY = /^\d*$/;
